export default theme => ({
  otherSubtitle: {
    fontWeight: '700',
    marginTop: '12px',
  },
  otherSubtitleSingleSelect: {
    marginTop: '24px',
  },
  otherDetails: {
    marginLeft: '24px',
  },
  textField: {
    paddingRight: '12px',
    width: '100%',
    maxWidth: '300px',
  },
});
